import{Locale as e}from"../../../locale/Locale.enum.mjs";const a={fixedLength:new Map([[e.ja,"固定長"]]),variableLength:new Map([[e.ja,"可変長"]])};export{a as OptionalItemLengthNameConfig};
